export default async function profile({ next, store }) {
    const loggedIn = store.getters.isLoggedIn
    const currentUser = store.getters["profile"].email
    if (loggedIn && !currentUser) {
         store.dispatch("getProfile").finally(() => next())
        return
    }
    next()
}
